import * as yup from 'yup';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useValidateSchema } from '../../../../hooks/providers/useValidateSchema';
import IFormError from '../../../../interfaces/IFormError';
import WizardButton from '../../components/WizardButton';
import WizardTextField from '../../components/WizardTextField';
import { useTenantDomainService } from '../../../../hooks/services/useTenantDomainService';
import { WizardContent } from '../../components/WizardContent';
import { ShowError, StyledAlert } from '../../components/ErrorMessage';
import { WizardTitle } from '../../components/WizardTitle';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import ILocalSettings from '../../../../interfaces/ILocalSettings';
interface ITenantDomainProps {
  setStep: (step: number) => void;
  step: number;
}

const TenantDomain = (props: ITenantDomainProps) => {
  const [, setSearchParams] = useSearchParams();
  const [tenantDomain, setTenantDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<IFormError | null>(null);
  const [localSettings, setLocalSettings] = useState<ILocalSettings>({});
  const validation = useValidateSchema();
  const tenantDomainService = useTenantDomainService();
  const [isError, setIsError] = useState(false);
  const localStorage = useLocalStorage();

  const schema = yup.object({
    tenantDomain: yup.string().required('É necessário informar o domínio.'),
  });

  const getLocalSettings = () => {
    setLocalSettings(localStorage.getItem('localSettings'));

    if (localSettings?.tenantDomain) {
      setTenantDomain(localSettings.tenantDomain);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const result = await validation.validate(schema, { tenantDomain }).then(result => {
      return result;
    });

    if (!result.isValid) {
      setErrors(result.errors);
      return;
    } else {
      setErrors(null);
    }
    setLoading(true);
    await tenantDomainService
      .getTenantDomain({ tenantDomain })
      .then(async () => {
        setLoading(false);
        setSearchParams({ tenantDomain });

        localStorage.setItem('localSettings', { tenantDomain });

        await props.setStep(props.step + 1);
      })
      .catch(error => {
        setLoading(false);
        setIsError(true);
      });
  };

  useEffect(() => {
    getLocalSettings();
    localStorage.removeItem('medicalCertificate');
  }, []);

  return (
    <WizardContent>
      <WizardTitle>Informe o domínio da empresa em que trabalha:</WizardTitle>
      <form onSubmit={handleSubmit}>
        <WizardTextField
          placeholder="exemplo: seniornortepr.com.br"
          label="Domínio"
          value={tenantDomain}
          onChange={e => {
            setTenantDomain(e.target.value.toLowerCase());
            setIsError(false);
          }}
          error={Boolean(errors?.tenantDomain)}
          helperText={Boolean(errors?.tenantDomain) ? errors?.tenantDomain : ''}
          sx={{ marginBottom: '5px', width: '300px' }}
        />
        <div>
          <ShowError show={isError}>
            <StyledAlert severity="error">
              Ops, não conseguimos localizar a empresa informada. Tente novamente, ou entre em contato com o RH.
            </StyledAlert>
          </ShowError>
        </div>

        <WizardButton type="submit" isLoading={loading} disabled={loading} sx={{ marginTop: '5px' }}>
          PRÓXIMO
        </WizardButton>
      </form>
    </WizardContent>
  );
};

export default TenantDomain;
